export default __webpack_public_path__ + "static/media/ROT.7b36ad9f.svg";